module.exports = "<div class=\"feature-box\" (click)=\"onSelect()\" [class.selected]=\"feature.selected\">\n  <div class=\"icon\"><i class=\"oi\" [class]=\"feature.icon\"></i></div>\n  <div class=\"name\" [class.selected]=\"selected\" *ngIf=\"showName\">{{ feature.display_name }}</div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /app/src/app/shared/components/feature-bubble/feature-bubble.template.html
// module id = ../../../../../src/app/shared/components/feature-bubble/feature-bubble.template.html
// module chunks = 12